export default __webpack_public_path__ + "static/media/kalash.773142ef.webp";